'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _components2 = require('components');

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    RightPanel: {
        displayName: 'RightPanel'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Header/default/RightPanel.js',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var RightPanel = _wrapComponent('RightPanel')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(RightPanel, _Component);

    function RightPanel() {
        (0, _classCallCheck3.default)(this, RightPanel);
        return (0, _possibleConstructorReturn3.default)(this, (RightPanel.__proto__ || (0, _getPrototypeOf2.default)(RightPanel)).apply(this, arguments));
    }

    (0, _createClass3.default)(RightPanel, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                user = _props.user,
                lang = _props.lang;

            var result = void 0;
            var postpone = void 0;
            if (!user) {
                result = _react3.default.createElement(
                    'li',
                    { className: 'hidden-xs' },
                    _react3.default.createElement(_components2.RegistrationHeader, null)
                );
            } else {
                if (user.count_postpone > 0) {
                    var isActive = " active_icon";
                    postpone = _react3.default.createElement(
                        'li',
                        null,
                        _react3.default.createElement(
                            _reactRouter.Link,
                            { to: '/postpone', className: 'ibonus-shopping-cart' },
                            _react3.default.createElement(
                                'div',
                                { className: 'header_icon-holder' },
                                _react3.default.createElement('i', { className: "fa fa-cart-arrow-down header_icon " + isActive }),
                                user.count_postpone ? _react3.default.createElement(
                                    'div',
                                    { className: 'header_icon_text-holder' },
                                    _react3.default.createElement(
                                        'span',
                                        { className: 'header_icon_text' },
                                        user.count_postpone
                                    )
                                ) : null
                            )
                        )
                    );
                }
            }

            return _react3.default.createElement(
                'ul',
                { className: 'right' },
                postpone,
                _react3.default.createElement(
                    'li',
                    null,
                    _react3.default.createElement(_components2.HeaderWishIcon, null)
                ),
                _react3.default.createElement(
                    'li',
                    null,
                    _react3.default.createElement(_components2.MiniBasket, null)
                ),
                _react3.default.createElement(
                    'li',
                    { className: 'hidden-xs' },
                    _react3.default.createElement(_components2.AuthHeader, null)
                ),
                result
            );
        }
    }]);
    return RightPanel;
}(_react2.Component), _class.propTypes = {
    lang: _react2.PropTypes.object,
    user: _react2.PropTypes.object
}, _temp));

exports.default = RightPanel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/default/RightPanel.js
// module id = 1678
// module chunks = 0